// Generated from SVG to Code Figma Plugin
import React from 'react';

export const Help = (props: { className?: string }) => (
    <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={props.className}>
        <path
            d='M7.38071 7.29968C7.59231 6.69818 8.00995 6.19098 8.55967 5.86791C9.10939 5.54483 9.75572 5.42674 10.3842 5.53453C11.0126 5.64233 11.5826 5.96906 11.9933 6.45686C12.4039 6.94466 12.6287 7.56205 12.6277 8.19967C12.6277 9.99966 9.92771 10.8997 9.92771 10.8997M9.99971 14.4996H10.0087M1.89252 13.9074C2.02486 14.2412 2.05432 14.607 1.97712 14.9577L1.01862 17.9187C0.987738 18.0689 0.995723 18.2244 1.04182 18.3706C1.08792 18.5168 1.1706 18.6488 1.28202 18.7541C1.39345 18.8594 1.52992 18.9345 1.6785 18.9723C1.82708 19.01 1.98285 19.0092 2.13102 18.9699L5.20272 18.0717C5.53366 18.0061 5.87639 18.0347 6.19182 18.1545C8.11366 19.052 10.2907 19.2419 12.3389 18.6906C14.3871 18.1394 16.1748 16.8825 17.3866 15.1416C18.5984 13.4008 19.1564 11.2879 18.9622 9.17576C18.7679 7.0636 17.8339 5.08792 16.325 3.59728C14.816 2.10665 12.829 1.19686 10.7147 1.02843C8.60027 0.860005 6.49434 1.44376 4.76842 2.67672C3.04249 3.90967 1.8075 5.71258 1.28133 7.76735C0.755152 9.82212 0.971614 11.9967 1.89252 13.9074Z'
            stroke='currentColor'
            stroke-width='2'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
    </svg>
);

export default Help;
